<template>
  <div class="content">
    <div class="info">
      <div class="i_left">
        <video v-if="info.video_link &&type==2" class="video_show" ref="videoPlayer" controls>
          <source :src="info.video_link" type="video/mp4" />
        </video>
        <el-image v-else :src="info.picture_link_list[index]" fit="contain"></el-image>
        <div class="imgs">
          <el-image
            v-for="(item,i) in info.picture_link_list"
            @click="show(i)"
            :key="i"
            :src="item"
            fit="cover"
          ></el-image>
          <video v-if="info.video_link" class="video" :src="info.video_link" @click="open()"></video>
          <!-- <video src="https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4"></video> -->
        </div>
      </div>
      <div class="i_right">
        <p class="i_title">{{info.product_name}}</p>
        <p class="i_price">${{info.product_price}}</p>
        <p class="i_text">Brief Description</p>
        
    <div class="ql-container ql-snow mt-20">
      <div class="ql-editor" v-html="info.brief_description"></div>
    </div>
        <!-- <div class="mt-20" v-html="info.brief_description"></div> -->

        <el-button type="primary" @click="buy()">BUY</el-button>
      </div>
    </div>
    <div class="down">
      <p class="d_title">Product Description</p>
      
    <div class="ql-container ql-snow text mt-20">
      <div class="ql-editor" v-html="info.main_description"></div>
    </div>
      <!-- <div class="mt-20" v-html="info.main_description"></div> -->
    </div>
  </div>
</template>

<script>
import { adminProductInfo } from "@/request/api";
import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
Vue.use(VueQuillEditor);
export default {
  name: "HomeView",
  data() {
    return {
      type: -1,
      info: "",
      index: 0,
      list: [
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
      ],
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
    };
  },
  mounted() {
    console.log(this.$route.query.info);
    this.info = this.$route.query.info;
  },
  created() {},
  methods: {
    open() {
      this.type = 2;
    },
    buy() {
      window.open(this.info.buy_link, "_blank");
    },
    show(i) {
      this.index = i;
      this.type = 1;
    },
    getList() {
      adminProductInfo({
        page: this.page,
        page_size: this.size
      }).then(res => {
        console.log(res);
        this.list = res.results[0].results;
      });
    }
  }
};
</script>

<style scoped>
.info {
  display: flex;
  justify-content: center;
  margin: 100px 0 0;
}
.i_left {
  text-align: left;
}
.i_left > .el-image {
  width: 500px;
  height: 700px;
  border: 1px solid #b4b4b4;
}
.i_left > .video_show {
  width: 500px;
  height: 700px;
  border: 1px solid #b4b4b4;
}
.imgs {
}
.imgs .el-image {
  width: 70px;
  height: 70px;
}
.video {
  width: 70px;
  height: 70px;
}
.i_right {
  width: 600px;
  margin-left: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.i_title {
  font-size: 40px;
}
.i_price {
  font-size: 30px;
  margin: 30px auto 40px;
}
.i_text {
  font-size: 20px;
}
.el-button {
  width: 200px;
  height: 80px;
  font-size: 30px;
  margin-top: auto;
}
.down {
  margin: 100px 0;
}
.d_title {
  font-size: 26px;
}
.mt-20 {
  margin-top: 20px;
}
.text {
  width: 80%;
  margin: 50px auto;
}
.ql-container.ql-snow {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Details.vue